import { useEffect, useState } from "react";
import { Logo } from "./Logo";
import { WHATSAPP_LINK, NAV_LINKS } from "@/config";

export const WaIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12.04 2a9.9 9.9 0 0 0-8.4 15.2L2 22l4.9-1.6A9.9 9.9 0 1 0 12.04 2Zm5.77 14.06c-.24.68-1.4 1.3-1.94 1.35-.5.05-1.13.24-3.8-.98-2.98-1.37-4.85-4.6-5-4.82-.14-.21-1.2-1.7-1.2-3.24s.81-2.3 1.1-2.61c.29-.31.62-.39.83-.39l.6.01c.19.01.45-.07.7.58.26.68.87 2.33.95 2.5.07.17.12.37.02.58-.1.21-.15.34-.3.53-.14.17-.3.38-.43.51-.14.14-.29.3-.12.58.17.29.75 1.26 1.6 2.05 1.1 1.01 2.02 1.32 2.3 1.47.29.14.46.12.63-.07.17-.2.72-.87.91-1.17.19-.29.38-.24.64-.14.26.1 1.65.83 1.93.98.29.14.48.21.55.34.07.12.07.71-.17 1.4Z" />
  </svg>
);

const goTo = (target) => (e) => {
  e.preventDefault();
  if (target === 0) {
    if (window.__lenis) window.__lenis.scrollTo(0);
    else window.scrollTo(0, 0);
    return;
  }
  if (window.__lenis) window.__lenis.scrollTo(target, { offset: -90 });
  else document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
};

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-ink/80 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <a href="/" onClick={goTo(0)} data-testid="nav-logo-link" aria-label="fullshine.detailing">
          <Logo />
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={goTo(l.href)}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="text-sm text-white/60 hover:text-aqua transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={WHATSAPP_LINK}
          target="_blank"
          rel="noreferrer"
          data-testid="nav-whatsapp-cta"
          className="inline-flex items-center gap-2 rounded-full bg-wa px-4 md:px-5 py-2.5 text-sm font-semibold text-[#06120b] transition-all duration-300 hover:brightness-110 hover:shadow-[0_0_24px_rgba(37,211,102,0.4)]"
        >
          <WaIcon size={16} />
          <span className="hidden sm:inline">Pedir cita</span>
          <span className="sm:hidden">Cita</span>
        </a>
      </div>
    </header>
  );
};

export default Nav;
